// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__15Ifu","col":"styles_col__1YYLH","fulfillmentStatus":"styles_fulfillmentStatus__25YfX","emailCol":"styles_emailCol__29_99"};